import * as Sentry from "@sentry/browser";

import { FLAG_REMOVE_TEST_ID, FLAG_USE_CONSOLE_LOGGER } from "../constants";
import Cookies from "../cookies";
import * as dialog from "../dialog";

import ClientError from "./clientError";
import ServerError from "./serverError";

function createError(status, response = {}) {
    if (status >= 400 && status < 500) {
        const { title, message, ...extra } = response;
        return new ClientError(status, title, message, extra);
    }

    if (status >= 500 && status < 600) {
        return new ServerError(status);
    }

    return new Error("We're experiencing a problem. Please try again and if the problem persists, contact us at support@zeplin.io.");
}

// eslint-disable-next-line complexity
function handleError(error, handlers) {
    var dialogInit = {
        title: error.title,
        message: error.message
    };

    if (FLAG_USE_CONSOLE_LOGGER) {
        console.error(error);
    }

    if (error instanceof ServerError) {
        if (!handlers) {
            dialog.create(dialogInit);
        } else if ("serverErrorHandler" in handlers) {
            handlers.serverErrorHandler(error);
        } else {
            if ("serverErrorDialogCallback" in handlers) {
                dialogInit.done = {
                    cb: handlers.serverErrorDialogCallback
                };
            } else if ("dialogCallback" in handlers) {
                dialogInit.done = {
                    cb: handlers.dialogCallback
                };
            }

            dialog.create(dialogInit);
        }
    } else if (error instanceof ClientError) {
        if (error.status === 401) {
            if (handlers && "clientErrorHandler" in handlers && typeof handlers.clientErrorHandler === "object") {
                var statusHandler = handlers.clientErrorHandler[401];
                if (typeof statusHandler === "function") {
                    statusHandler();
                    return;
                }
            }
            Cookies.remove("userToken");
            Cookies.remove("mfaToken");
            localStorage.removeItem("user");
            Sentry.setUser(null);

            dialog.create({
                title: error.title,
                message: error.message
            }, {
                defer: true
            });

            Zeplin.requireLogin();
        } else {
            if (error.status === 400) {
                Sentry.captureException(error);
            }

            if (!handlers) {
                dialog.create(dialogInit);
            } else if ("clientErrorHandler" in handlers) {
                var clientErrorHandler = handlers.clientErrorHandler;

                if (typeof clientErrorHandler === "function") {
                    // catchall handler
                    clientErrorHandler(error);
                } else if (typeof clientErrorHandler === "object") {
                    var statusHandler = clientErrorHandler[error.status];

                    if (typeof statusHandler === "function") {
                        statusHandler(error);
                    } else if ("default" in clientErrorHandler) {
                        clientErrorHandler.default(error);
                    }
                } // else noop();
            } else {
                if ("clientErrorDialogCallback" in handlers) {
                    dialogInit.done = {
                        cb: handlers.clientErrorDialogCallback
                    };
                } else if ("dialogCallback" in handlers) {
                    dialogInit.done = {
                        cb: handlers.dialogCallback
                    };
                }

                dialog.create(dialogInit);
            }
        }
    } else {
        Sentry.captureException(error);

        if (handlers && "fallbackHandler" in handlers) {
            handlers.fallbackHandler();
        } else {
            let initData = FLAG_REMOVE_TEST_ID ? null : { testid: "genericErrorDialog" };
            dialog.create(initData);
        }
    }
}

export { createError, handleError };
